module.exports = __webpack_public_path__ + "media/images/category_icons/restaurants-bb6a8ee8b3453fb77ad39f9d7b6754a0.svg";